class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.slider');
    this.sliderItems = this.slider ? this.slider.querySelectorAll('.slider__slide') : [];
    this.prevButton = this.querySelector('.slider-button--prev');
    this.nextButton = this.querySelector('.slider-button--next');

    if (!this.slider || !this.sliderItems.length || !this.prevButton) {
      return;
    }

    this.initPages();
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.slider.addEventListener('scroll', this.update.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );

    if (this.sliderItemsToShow.length < 2) {
      return;
    }

    requestAnimationFrame(() => {
      const sliderWidth = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      if (sliderWidth === 0 || isNaN(sliderWidth)) {
        return;
      }

      this.sliderItemOffset = sliderWidth;

      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
          this.sliderItemOffset
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

      this.update();
    });
  }

  update() {
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", "disabled");
      this.prevButton.style.opacity = "0.5";
    } else {
      this.prevButton.removeAttribute("disabled");
      this.prevButton.style.opacity = "1";
    }

    this.nextButton.removeAttribute("disabled");
    this.nextButton.style.opacity = "1";
  }

  slideTo(index) {
    const targetSlide = this.sliderItems[index];
    this.slider.scrollTo({
      left: targetSlide.offsetLeft,
      behavior: 'smooth'
    });
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;

    const isVisible = element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
                      element.offsetLeft >= this.slider.scrollLeft;

    return isVisible;
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = event.currentTarget.dataset.step || 1;
    const isNext = event.currentTarget.name === "next";

    if (isNext) {
      if (this.currentPage >= this.totalPages) {
        this.slideTo(0);
      } else {
        this.slideScrollPosition =
          this.slider.scrollLeft + step * this.sliderItemOffset;
        this.slider.scrollTo({
          left: this.slideScrollPosition,
          behavior: 'smooth',
        });
      }
    } else {
      this.slideScrollPosition =
        this.slider.scrollLeft - step * this.sliderItemOffset;
      this.slider.scrollTo({
        left: this.slideScrollPosition,
        behavior: 'smooth',
      });
    }
  }

  connectedCallback() {
    this.initThumbnails();
  }

  initThumbnails() {
    const thumbnails = document.querySelectorAll('.product__thumbnail');

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        this.slideTo(index);
      });
    });
  }
}

customElements.define("product-gallery", ProductGallery);
